import * as Cards from "./Cards";
import * as Links from "./Links";
import * as Misc from "./Misc";
import * as Sections from "./Sections";

export const Menu = {
  ...Cards,
  ...Links,
  ...Sections,
  ...Misc,
};
